import React, { useState } from 'react';

import { featuredByOptions } from '../data/featuredByOptions';

import InputList from '../../InputList';
import FilterResetButton from '../FilterResetButton';
import FilterTitle from '../FilterTitle';

/**
 * FilterFeatured
 *
 * Filter books by featured
 *
 * @param {Object} props
 * @param {string} props.context
 * @param {Object} props.setStart
 */
const FeaturedFilter = ({ context, setStart, scrollToTop }) => {
  const [ isActive, setIsActive ] = useState( !!context.filterBy );
  const [ checked, setChecked ] = useState( context.filterBy ); // string

  const filteredOptions = context.hideAwardWinners === 'true' ? [ ...featuredByOptions ].filter( ( option ) => option.label !== 'Award Winners' ) : [ ...featuredByOptions ];

  const handleFilter = ( e ) => {
    setStart( 0 );
    e.target.closest( '.inner-blocks-wrapper' ).setAttribute( 'data-filter-by', e.target.value );
    setChecked( e.target.id );
    scrollToTop();
  };

  const filterTitleClickHandler = () => {
    setIsActive( cur => !cur );
  };

  return (
    <li className={ `filters__list-item text-[#121212] ${isActive ? 'is-active' : 'is-inactive'}` }>
      <FilterTitle title="Featured" classes={ `${isActive ? 'mt-0 mb-10' : ''}` } onClick={ filterTitleClickHandler } />
      <InputList options={ filteredOptions } type="radio" name="featured" label={ false } checked={ checked } onChangeHandler={ handleFilter } />
      <FilterResetButton setStart={ setStart } checked={ checked } setChecked={ setChecked } dataFilter="data-filter-by" scrollToTop={ scrollToTop } />
    </li>
  );
};

export default FeaturedFilter;
